
import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/Button';
import { Link } from 'react-router-dom';

const StrategyDiscovery = () => {
  const benefits = [
    "Understand your firm's opportunities with AI",
    "Identify risks before they become problems",
    "Get clarity on your next best strategic moves"
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-background/90 to-background">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Start With a Free 60-Minute <span className="text-gradient">Discovery Session</span>
            </h2>
            <p className="text-lg text-white/80 mb-6">
              No pressure. No obligation. Just expert insight into how AI can unlock growth and protection for your firm.
            </p>
            <p className="text-white/80 mb-8">
              In this complimentary session, we'll assess your firm's current position, identify key opportunities and risks, and outline actionable next steps you can take immediately — whether you decide to work with us further or not.
            </p>
            
            <div className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="bg-green-500/20 rounded-full p-1">
                    <Check className="h-5 w-5 text-green-400" />
                  </div>
                  <p className="text-white/90">{benefit}</p>
                </div>
              ))}
            </div>
            
            <Link to="/services/strategy/free-discovery-session">
              <Button variant="glass" size="lg" className="text-base">
                Schedule My Free Discovery Session
              </Button>
            </Link>
          </div>
          
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 md:p-8">
            <h3 className="text-2xl font-bold mb-6 text-white">
              After Your Discovery Session: Choose the Plan That Fits
            </h3>
            <p className="text-white/80 mb-4">
              Choose the path that matches your goals and ambition.
            </p>
            <p className="text-white/80 mb-6">
              Following your complimentary Discovery Session, we'll recommend the best next step based on your firm's goals, readiness, and ambition. Whether you need a fast-start foundation or a full firm-wide AI transformation, we offer a range of tailored options designed to meet you where you are.
            </p>
            
            <Link to="/services/strategy/packages">
              <Button variant="outline" size="lg" className="w-full">
                View Strategy Packages
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrategyDiscovery;
